import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Spinner, Button } from '@components/atomic';
import { AuthInput, Notice } from '@components/domain';
import { IdIcon, LockIcon, UserIcon } from '@assets/icon';
import { ReactComponent as LogoTypo } from '@assets/logo/logo_typo.svg';
import { MediaQueries, BREAKPOINT_PHONE } from '@style/MediaQuery';
import { useForm } from '@hooks';
import { useUserContext } from '@contexts/UserContext/UserProvider';
import { USER_SIGNUP } from '@contexts/UserContext/types';

const SignUpWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
`;

const InnerContainer = styled.div`
  max-width: 740px;
  min-height: 700px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  border: 1px solid #e4e4e4;
  border-radius: 24px;

  ${MediaQueries(BREAKPOINT_PHONE)} {
    max-height: none;
    border: 0;
  }
`;

const Logo = styled(LogoTypo)`
  width: 160px;
  height: 160px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 420px;
  width: 100%;
`;

const SignUp = () => {
  const { onAuth, isLoading } = useUserContext();
  const [isCheck, setIsCheck] = useState(false);
  const { errors, handleChange, handleSubmit } = useForm({
    initialValues: {
      email: '',
      fullName: '',
      password: '',
      passwordConfirm: '',
    },
    onSubmit: async (values) => {
      const signInfo = { ...values };
      delete signInfo.passwordConfirm;

      try {
        await onAuth({ values: signInfo, type: USER_SIGNUP });
      } catch (error) {
        setIsCheck(true);
      }
    },
    validate: ({ email, fullName, password, passwordConfirm }) => {
      const errors = {};
      if (!email) errors.email = '이메일을 입력해주세요.';
      if (!fullName) errors.fullName = '이름을 입력해주세요.';
      if (!password) errors.password = '비밀번호를 입력해주세요.';
      if (!passwordConfirm)
        errors.passwordConfirm = '비밀번호를 한번 더 입력해주세요.';
      if (password && passwordConfirm && password !== passwordConfirm)
        errors.passwordConfirm = '비밀번호가 일치하지 않습니다.';
      return errors;
    },
  });

  return (
    <SignUpWrapper>
      <InnerContainer>
        <Logo />
        <Form onSubmit={handleSubmit}>
          <AuthInput
            icnUrl={IdIcon}
            name="email"
            placeholder="아이디를 입력해주세요."
            onChange={handleChange}
            errorMessage={errors.email}
          />
          <AuthInput
            icnUrl={UserIcon}
            name="fullName"
            placeholder="이름을 입력해주세요."
            onChange={handleChange}
            errorMessage={errors.fullName}
          />
          <AuthInput
            icnUrl={LockIcon}
            name="password"
            type="password"
            placeholder="비밀번호를 입력해주세요."
            onChange={handleChange}
            errorMessage={errors.password}
          />
          <AuthInput
            icnUrl={LockIcon}
            name="passwordConfirm"
            type="password"
            placeholder="비밀번호를 한번 더 입력해주세요."
            onChange={handleChange}
            errorMessage={errors.passwordConfirm}
          />
          <Notice auth="signUp" isCheck={isCheck} />
          <Button
            onClick={handleSubmit}
            width="100%"
            height="50px"
            type="submit"
            disabled={isLoading}
          >
            회원가입 {isLoading ? <Spinner /> : ''}
          </Button>
        </Form>
      </InnerContainer>
    </SignUpWrapper>
  );
};

export default SignUp;
